import { render, staticRenderFns } from "./StagiaireEdit.vue?vue&type=template&id=bca9d10e&"
import script from "./StagiaireEdit.vue?vue&type=script&lang=js&"
export * from "./StagiaireEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports